import { Suspense } from 'react';
import { Card } from '@core/design-system/card/app';
import { Skeleton } from '@core/design-system/tailwind/ui/skeleton';

export const withSpacingContainer = (Component: any) => (props: any) => {
  return (
    <section className="print:hidden mb-10">
      <Suspense
        fallback={
          <>
            {Array.from({ length: 4 }).map((_, i) => (
              <Card
                key={i}
                className="p-4 space-y-2 col-span-12 md:col-span-6 lg:col-span-3"
              >
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-6 w-48" />
              </Card>
            ))}
          </>
        }
      >
        <Component {...props} />
      </Suspense>
    </section>
  );
};
